import type { AxiosInstance } from 'axios';
import { injectable } from 'inversify';
import { IGameReviewProvider } from 'interfaces/providers/IGameReviewProvider';
import { Result } from 'services/Result';
import { IApiPlaysWithBallFinals } from 'interfaces/session/IApiPlaysWithBallFinals';

@injectable()
export class GameReviewService implements IGameReviewProvider {
  private axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getReviewPlays = async (sessionId: string) => {
    const response = await this.axiosInstance.get<Result<IApiPlaysWithBallFinals>>(`api/review/${sessionId}`);
    if (response.data && !response.data.isError && response.data.data) {
      const r = response.data.data as IApiPlaysWithBallFinals;
      return r;
    }
    throw new Error(`Error getting session plays: ${response.status}`);
  };
}
